/**
 * Compares two version strings and returns:
 * a negative value if a < b,
 * a positive value if a > b,
 * zero if both are equal
 *
 * Example:
 * compareVersionStrings('1.9.2', '1.10') == -1
 * compareVersionStrings('2', '2.0.0') == 0
 * compareVersionStrings('2', '1.5') == 1
 *
 * It supports numbers too:
 * compareVersionStrings(2.5, '2.5.1') == -1
 *
 * @param a -
 * @param b -
 * @returns -1, 0, 1
 */
// eslint-disable-next-line id-length
export function compareVersions(a: number | string, b: number | string): number {

    if (a === undefined || a === '' || b === undefined || b === '') {
        throw new Error('Invalid Arguments. Expected two versions as strings or numbers');
    }

    const versions = [a, b]
        .map(version => version.toString())
        .map(version => ({
            parts: version.split('.').map(part => parseInt(part || '0', 10)),
            text: version,
        }));

    const maxPartCount = Math.max(versions[0].parts.length, versions[1].parts.length);

    for (let index = 0; index < maxPartCount; index++) {
        const aPart = versions[0].parts[index] || 0;
        const bPart = versions[1].parts[index] || 0;

        if (aPart > bPart) {
            return 1;
        } else if (aPart < bPart) {
            return -1;
        }
    }

    return 0;
}

export function leftPad(input: number, size: number): string {
    let str = String(input);
    while (str.length < size) {
        str = `0${str}`;
    }
    return str;
}
